export default function({ store, next, router }) {
    if(!store.getters.getSettings.learner_registration){
       router.replace({
            name: "login-tenants"
      });
    }
    next();
}
